import React, { useState, useRef, useEffect } from "react";
import { withSidebar } from "../hoc/withSidebar";
import { useTranslation } from "react-i18next";
import ResponsiveDataGrid from "../custom/containers/ResponsiveDataGrid";
import { tracePaymentHeading } from "../../constants/TracePaymentConstant";
import actions from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import CardList from "../custom/containers/cardList";
import moment from "moment";
import { formatDate, listProps, getComponentAccess } from "../../utils/helper";
import ERPSRecallRejectSearch, { getDateLimits, billerDetails } from "../custom/ERPSRecallRejectSearch";
import { ResponsiveBox, Typography } from "../primitives";


const TraceManagement = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {
        history,
        location: { pathname, state },
    } = props;

    const tracePaymentResponse = useSelector(
        (state) => state.tracePaymentReducer
    );
   
     
    const user = useSelector((state) => state.loginUserReducer.user);
    const loggedInBillerId = user?.billerNonVolatileDto?.biller_id;
    const internalBMOUserId = user?.internalBMOUserId;
    const [errorMessage, setErrorMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const [rowPerPage, setRowPerPage] = useState(100);
    const [dataCount, setDataCount] = useState(0);
 
    const componentAccess = state?.componentAccess
            || getComponentAccess( { function_type_code: "TP", label_type_code: "TE" }, user );

    const selectedFiNumber = useSelector((state) => state.fiReducer?.selectedFi);

    const fiNumberValue = selectedFiNumber ? selectedFiNumber : user?.fiNumber;

    const sortDetails = [
        {
            name: t("erps.common.label.effectiveDate"),
            value: "ED"
        },
    ];
    
   useEffect(() => {
      if (state?.fromDetailPage) {
        Object.keys(searchValues).filter(key => actualCriteria[key]).forEach(key => searchValues[key] = actualCriteria[key]);
        setPageNumber(actualCriteria.offset / actualCriteria.limit);
        setRowPerPage(actualCriteria.limit);
        state.fromDetailPage = null;  // resetting the coming-from-detail-page flag
        if (state.isTraceInitiated)
          loadResults(actualCriteria, " (After Recall)");
      } else {  // reset search resutls previously saved in the reducer
        dispatch({
          type: "GET_TRACE_SUCCESS",
          data: { data: null, tracePaymentDetails: null },
        });
      }
    }, []);

    useEffect(() => {
        if (tracePaymentResponse) {
            const tracePaymentRes = tracePaymentResponse?.tracePaymentData?.data;
            //const tracePaymentRes = tracePaymentResponse.tracePaymentData;
            if (tracePaymentRes?.length) {
                for (let i = 0; i < tracePaymentRes.length; i++) {
                    tracePaymentRes[i].seqNo = i + 1 + actualCriteria.offset;
                    tracePaymentRes[i].id = tracePaymentRes[i].payment_id;
                }
            }
            setDataCount(tracePaymentResponse.tracePaymentData?.count || 0);
            setTraceData(tracePaymentRes);
        }
    }, [tracePaymentResponse]);


    const dates = getDateLimits();

    const initialSearchValues = {
        paymentFromDate: null,
        paymentToDate: dates.today,
        searchBy: billerDetails[0].value,   // "billerId"
        transactionToAmount: "",
        transactionFromAmount: null,
        verificationNumber: "",
        bmoBillerId: "",
        billerName: "",
        billerCustomerNumber: "",
        fiCustomerName: "",
        requestFrom: "tracePayment",
        sortBy: "Biller ID"
    };

    const [searchValues, setSearchValues] = useState(initialSearchValues);

    const [actualCriteria, setActualCriteria] = useState(
        state?.fromDetailPage ? tracePaymentResponse?.tracePaymentDetails : { ...initialSearchValues, offset: 0, limit: rowPerPage }
    );
    const [traceData, setTraceData] = useState(state?.fromDetailPage && tracePaymentResponse?.traceData?.data || null);


    const handleReset = () => {
        setSearchValues({ ...initialSearchValues });
        setActualCriteria({ ...initialSearchValues, offset: 0 });
        setPageNumber(0);
        setErrorMessage(null);

        dispatch({
            type: "GET_TRACE_SUCCESS",
            data: { data: null, tracePaymentDetails: null },
        });
    };

    const handleSearch = (groomedValues) => {
        if (groomedValues.paymentToDate)
            groomedValues.paymentToDate = formatDate(moment(groomedValues.paymentToDate).format());

        if (pageNumber)
            setPageNumber(0);
        if (actualCriteria.offset)
            actualCriteria.offset = 0;

        groomedValues.limit = actualCriteria.limit;
        groomedValues.offset = actualCriteria.offset;
        setActualCriteria({ ...groomedValues });

        if (groomedValues.searchBy === billerDetails[0].value)  // "billerId"
            delete groomedValues["billerName"];  // NOT sending billerName when searching by biller id
        else if (groomedValues.searchBy === billerDetails[1].value)  //  "billerName"
            delete groomedValues["bmoBillerId"]; // NOT sending bmoBillerId when searching by biller Name

        //console.log("bmoBillerId = " + groomedValues.bmoBillerId + ",   billerId = " + groomedValues.billerId);
        //console.log("groomedValues.bmoBillerId || internalBMOUserId?.slice(0, -2) || loggedInBillerId:  " + (groomedValues.bmoBillerId || internalBMOUserId?.slice(0, -2) || loggedInBillerId));
        groomedValues.billerId = groomedValues.bmoBillerId || internalBMOUserId?.slice(0, -2) || loggedInBillerId;

        //console.log("***************** SEARCHING ********************************");
        //console.log("groomedValues: " + listProps(groomedValues, true));
        loadResults(groomedValues, " (search)");
    };

    const loadResults = (queryParams, prompt) => {
        if (errorMessage)
            setErrorMessage(null);
        setLoading(true);

        dispatch(
            actions.tracePaymentActions.getTracePayments(
                queryParams,
                { ...props, history, setLoading, fiNumberValue, setErrorMessage }
            )
        );
    }

    const paginate = (values) => {  // 'values' has fields startOffset and endOffset (e.g., for 1st Page: 0,25;  2nd Page: 25,50;  3rd: 50,75...)
        actualCriteria.offset = values.startOffset;
        if (actualCriteria.limit !== (values.endOffset - values.startOffset)) // if the user changed the number of rows per page
            actualCriteria.limit = values.endOffset - values.startOffset;

        loadResults(actualCriteria, " (paginate)");
    };


    return (
        <div role="main">
            <ResponsiveBox ml={3}>
                <ERPSRecallRejectSearch
                    pageType="TP"
                    pageTitle={t("erps.paymenttrace.page.title")}
                    pageDescription={t("erps.transactionEnquiry.page.description")}
                    searchValues={searchValues}
                    setSearchValues={setSearchValues}
                    dates={dates}
                    loading={loading}
                    errorMessage={errorMessage}
                    componentAccess={componentAccess}
                    handleReset={handleReset}
                    handleSearch={handleSearch}
                />

                {(traceData !== null && traceData !== undefined && Array.isArray(traceData) && traceData.length > 0) ? (
                    <>
                        <ResponsiveBox className="manageUsers_table_visible">
                            <ResponsiveDataGrid
                                data={{
                                    rows: traceData,
                                    columns: tracePaymentHeading(),
                                    count: dataCount,
                                }}
                                sumOfColumnWidth="true"
                                initialLoading={loading}
                                pageNumber={pageNumber}
                                setPage={setPageNumber}
                                rowPerPage={rowPerPage}
                                onAnyPaginationAction={paginate}
                                tableLabelText={t("erps.transactionEnquiry.page.title")}
                                hideFooterPagination={false}
                                pageName={"transaction-enquiry"}
                            />
                        </ResponsiveBox>
                        <ResponsiveBox className="manageUsers_card_visible">
                            <CardList
                                data={{
                                    rows: traceData,
                                    columns: tracePaymentHeading(),
                                    count: tracePaymentResponse?.traceData?.count || 0
                                }}
                                onAnyPaginationAction={paginate}
                                hideFooterPagination={false}
                                pageName={"transaction-enquiry"}
                                pageNumber={pageNumber}
                                setPage={setPageNumber}
                                rowPerPage={rowPerPage}
                            />
                        </ResponsiveBox>
                    </>
                ) : (
                    <ResponsiveBox mt={1}>
                        <Typography variant="body1">
                            {(traceData?.length === 0)
                                ? (`0 ${t("erps.transactionEnquiry.page.resultfound")}`)
                                : (t("erps.availabledocuments.searchuser.notstarted", "Search not started"))
                            }
                        </Typography>
                    </ResponsiveBox>
                )}
            </ResponsiveBox>
        </div>
    );
};

export default withSidebar(TraceManagement);
